import { RouteObject } from "react-router-dom";
import RegistrationLayout from "src/layouts/RegistrationLayout";
import { Paths } from "../paths";
// import StateSelection from "src/pages/Onboarding/StateSelection";
import StateUnqualified from "src/pages/Onboarding/StateUnqualified";
import { Matches } from "../matches";
import Questions from "src/pages/Questions";
import ShippingAddress from "src/pages/Onboarding/ShippingAddress";
// import SSNVerification from "src/pages/VouchedVerification/SSNVerification";
import PageTrackerProvider from "src/context/PageTrackerProvider";
import { ProgressProvider } from "src/context/ProgressContext";
import AuthQueue from "src/pages/transitions/AuthQueue";
import QuestionsProvider from "src/context/QuestionsProvider";

export const registrationRoutes: RouteObject[] = [
  {
    element: (
      <PageTrackerProvider>
        <ProgressProvider>
          <QuestionsProvider>
            <RegistrationLayout />
          </QuestionsProvider>
        </ProgressProvider>
      </PageTrackerProvider>
    ),
    children: [
      {
        path: "registration",
        children: [
          {
            path: Paths.STATE_SELECTION,
            element: <AuthQueue />,
          },
          {
            path: "patient-criteria-Q1",
            element: <AuthQueue />,
          },
          {
            path: "patient-criteria-Q2",
            element: <AuthQueue />,
          },
          {
            path: "patient-criteria-Q3",
            element: <AuthQueue />,
          },
          {
            path: "patient-criteria-Q4",
            element: <AuthQueue />,
          },
          {
            path: "state-disqualification",
            element: <StateUnqualified />,
          },
        ],
      },
      {
        children: [
          {
            children: [
              {
                path: Paths.QUESTIONS,
                children: [
                  {
                    path: Matches.QUESTION_ID,
                    element: <Questions />,
                  },
                ],
              },
            ],
          },
          {
            path: "state-disqualification",
            element: <StateUnqualified />,
          },
          {
            path: "result-information",
            element: <AuthQueue />,
          },
          {
            path: "shipping-information",
            element: <ShippingAddress />,
          },
          {
            path: "reviews",
            element: <AuthQueue />,
          },
          {
            path: "identity-verification-1",
            element: <AuthQueue />,
          },

          {
            path: "identity-verification-2",
            element: <AuthQueue />,
          },
          {
            path: "identity-verification-3",
            element: <AuthQueue />,
          },
          {
            path: "payment-information",
            element: <AuthQueue />,
          },
          {
            path: "payment-confirmation",
            element: <AuthQueue />,
          },
        ],
      },
    ],
  },
];
